import { render, staticRenderFns } from "./riseRateWhiterList.vue?vue&type=template&id=2445abba&scoped=true&"
import script from "./riseRateWhiterList.vue?vue&type=script&lang=js&"
export * from "./riseRateWhiterList.vue?vue&type=script&lang=js&"
import style0 from "./riseRateWhiterList.vue?vue&type=style&index=0&id=2445abba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2445abba",
  null
  
)

export default component.exports